import { render, staticRenderFns } from "./DetailClaimOrDispute.vue?vue&type=template&id=785e66d4&scoped=true"
import script from "./DetailClaimOrDispute.vue?vue&type=script&lang=js"
export * from "./DetailClaimOrDispute.vue?vue&type=script&lang=js"
import style0 from "./DetailClaimOrDispute.vue?vue&type=style&index=0&id=785e66d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785e66d4",
  null
  
)

export default component.exports